import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ExpandMore,
  moment,
} from "../../Collections/Imports";
import GlobalDateRangePicker from "../../Components/CommonComponents/GlobalDateRangePicker";
import "./style.css";
import GlobalMultiSelect from "../../Components/CommonComponents/GlobalMultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { updateCampaignFilterData } from "../../Store/CampaignModule/filterSession";
import {
  useApiCallMutation,
  useGetApiCallQuery,
} from "../../Services/ApiCallService";
import {
  buyerModuleAPiENdPoints,
  campaignModuleAPiEndPoints,
  campaignTagsModuleAPiEndPoints,
  coreAPIEndsPoints,
} from "../../Config/APIsEndpoints";
import { updateLabelOptions } from "../../Store/Global/LabelOptions";
import { updateManagerOptions } from "../../Store/Global/ManagerOptions";
import { updateTypeOptions } from "../../Store/Global/TypeOptions";
import { updateBuyesOptions } from "../../Store/Global/BuyersOptions";
import { click } from "@testing-library/user-event/dist/click";
import CustomButton from "../../Components/CommonComponents/GlobalButton";
import {
  CampaignNameOptions,
  CampaignTagOptions,
} from "../../Store/CampaignModule";
import GlobalDropdown from "../../Components/CommonComponents/GlobalDropdown";
import { buyerNameOptions } from "../../Store/BuyerModule";

const CampaignFilters = (props) => {
  const {
    setOpen,
    isOpen,
    defaultValues,
    isEditMode,
    defaultCampaign,
    ClearFilters,
  } = props;

  const previousFilterData = useSelector(
    (state) => state?.campaignDataFilterSession?.filterData
  );
  const currentDate = new Date("July 01, 2020");
  console.log(">>>>>>>>>>>>>>>>>>>>>>>", defaultCampaign);

  // update Filter code /////////////////////////////////////////////////////////////////

  const [BuyerOptions, setBuyerOptions] = useState([]);

  //Status
  const [statusOptions, setStatusOptions] = useState([
    { label: "Active", value: "true" },
    { label: "Disabled", value: "false" },
  ]);

  useEffect(() => {
    setStatusOptions((prevOptions) => [AllOptions, ...prevOptions]);
  }, []);
  //Status
  //Type
  const [typeOptions, setTypeOptions] = useState([
    { label: "Redirect", value: "redirect" },
    { label: "Silence", value: "silence" },
  ]);

  useEffect(() => {
    setTypeOptions((prevTypeOptions) => [AllOptions, ...prevTypeOptions]);
  }, []);
  //Type

  const CampaignNameOpt = useSelector(
    (state) => state?.CampaignData?.campaignAllOptions?.CampaignNameOpt
  );

  console.log("CampaignNameOptCampoiagin777777777777777", CampaignNameOpt);

  const CampaignTagOpt = useSelector(
    (state) => state?.CampaignData?.campaignAllOptions?.CampaignTagOpt
  );

  console.log("CampaignNameOptCampoiagin777777777777777", CampaignTagOpt);

  const buyersOptions = useSelector(
    (state) => state?.buyersData?.buyerAllOptions?.buyerNameOpt
  );

  //Push new option All
  const [CampaignOptions, setCampaignOptions] = useState([]);
  const [TagOptions, setTagOptions] = useState([]);

  const AllOptions = { label: "All", id: 1, value: "All" };

  useEffect(() => {
    setCampaignOptions((prevOptions) => [AllOptions, ...CampaignNameOpt]);
  }, []);

  useEffect(() => {
    setTagOptions((prevOptions) => [AllOptions, ...CampaignTagOpt]);
  }, []);

  useEffect(() => {
    setBuyerOptions((prevOptions) => [AllOptions, ...buyersOptions]);
  }, [buyersOptions]);

  // console.log("Campoiagin777777777777777", CampaignOptions);

  const [selectedDateFilter, setSelectedDateFilter] = useState({
    startDate: new Date("July 01, 2020"),
    endDate: new Date(),
    key: "selection",
  });

  const AllFilterLength = useSelector(
    (state) => state?.campaignDataFilterSession?.filterData
  );

  // debugger;

  const dispatch = useDispatch();

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      status: "All",
      buyerId: ["All"],
      campaignTagsId: ["All"],
      campaignName: ["All"],
      label: ["All"],
      campaignType: "All",
    },
    // resolver: yupResolver(validationSchema),
    mode: "all",
  });

  //***********FORM SUBMISSION ********//
  const onFormSubmit = (data) => {
    // debugger;
    const filterData = {
      status: data?.status,
      buyerId: data?.buyerId,
      campaignName: data?.campaignName,
      campaignTagsId: data?.campaignTagsId,
      campaignType: data?.campaignType,
      fromDate: currentDate,
      toDate: data?.dateRange
        ? moment(data?.dateRange[0]?.endDate).endOf("day").toDate()
        : "",
    };
    dispatch(updateCampaignFilterData(filterData));
    setOpen(false);
  };

  // Call setFormValue after initialization
  useEffect(() => {
    if (previousFilterData && Object.keys(previousFilterData)?.length) {
      setFormValue(previousFilterData);
    }
  }, [previousFilterData]);

  // Set Form Value
  const setFormValue = (data) => {
    // debugger;
    const dateRange = {
      startDate: new Date(data?.fromDate),
      endDate: data?.toDate,
      key: "selection",
    };

    setValue("status", data?.status, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("buyerId", data?.buyerId, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("campaignName", data?.campaignName, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("campaignTagsId", data?.campaignTagsId, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("campaignType", data?.campaignType, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("dateRange", dateRange, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <>
      <Drawer
        anchor={"right"}
        open={isOpen}
        onClose={() => setOpen(false)}
        sx={{
          [`& .MuiDrawer-paper`]: {
            boxSizing: "border-box",
            top: "15px",
            borderRadius: "16px",
            maxWidth: "500px",
            width: "100%",
          },
        }}
      >
        <Box
          sx={{
            pt: "1rem",
            pr: "1rem",
            pl: "1rem",
          }}
        >
          <Stack
            spacing={{ xs: 1, sm: 2 }}
            direction="row"
            useFlexGap
            flexWrap="wrap"
            justifyContent={"space-between"}
          >
            <Box marginBottom={"15px"}>
              <Typography component="h6" variant="h6" fontWeight={600}>
                Filters
              </Typography>
            </Box>
            <Box marginBottom={"15px"}>
              <Typography
                component="h7"
                variant="h7"
                fontWeight={200}
                style={{ cursor: "pointer" }}
                onClick={ClearFilters}
              >
                Clear All
              </Typography>
            </Box>
          </Stack>

          <Divider
            sx={{
              mb: "20px",
            }}
          />

          <Box component={"form"} className="accordionGrid">
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultCampaign == "campaignName"
                  ? true
                  : defaultCampaign == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Campaign Name{" "}
                  {AllFilterLength.campaignName &&
                    AllFilterLength.campaignName.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength.campaignName.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="campaignName"
                  label=""
                  options={CampaignOptions || []}
                  required
                  error={!!errors.campaignName}
                  helperText={errors.campaignName?.message}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultCampaign == "status"
                  ? true
                  : defaultCampaign == "All"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Status{" "}
                  {AllFilterLength?.status && (
                    <span className="count-style">
                      <p>{AllFilterLength?.status && 1}</p>
                    </span>
                  )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalDropdown
                  control={control}
                  size="small"
                  name="status"
                  options={statusOptions}
                  required
                  error={!!errors.status}
                  helperText={errors.status?.message}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultCampaign == "buyerName"
                  ? true
                  : defaultCampaign == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Buyer{" "}
                  {AllFilterLength.buyerId &&
                    AllFilterLength.buyerId.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength.buyerId.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                {/* <GlobalInput control={control} name="buyerId" label="" /> */}
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="buyerId"
                  label=""
                  options={BuyerOptions || []}
                  required
                  error={!!errors.buyerId}
                  helperText={errors.buyerId?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultCampaign == "tag"
                  ? true
                  : defaultCampaign == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Tag{" "}
                  {AllFilterLength.campaignTagsId &&
                    AllFilterLength.campaignTagsId.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength.campaignTagsId.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                {/* <GlobalDropdown control={control} name="label" options={[]} /> */}
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="campaignTagsId"
                  label=""
                  options={TagOptions || []}
                  required
                  error={!!errors.campaignTagsId}
                  helperText={errors.campaignTagsId?.message}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultCampaign == "type"
                  ? true
                  : defaultCampaign == "All"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Type{" "}
                  {AllFilterLength.campaignType && (
                    <span className="count-style">
                      <p>{AllFilterLength.campaignType && 1}</p>
                    </span>
                  )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalDropdown
                  control={control}
                  size="small"
                  name="campaignType"
                  options={typeOptions}
                  required
                  error={!!errors.campaignType}
                  helperText={errors.campaignType?.message}
                />
              </AccordionDetails>
            </Accordion>
            {/* </Grid> */}

            {/* <Grid item xs={12}> */}
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultCampaign == "created"
                  ? true
                  : defaultCampaign == "All"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">Create Date</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <Controller
                  name="dateRange"
                  control={control}
                  render={({ field }) => (
                    <GlobalDateRangePicker
                      defaultRange={{
                        startDate: new Date(
                          new Date().setDate(new Date().getDate() - 60)
                        ),
                        endDate: new Date(),
                        key: "selection",
                      }}
                      {...field}
                    />
                  )}
                />
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
        <Box
          sx={{
            pt: "1rem",
            pr: "1rem",
            pl: "1rem",
          }}
        >
          <Stack
            direction="row"
            component={Box}
            useFlexGap
            flexWrap="wrap"
            justifyContent={"flex-end"}
            bottom={0}
            marginTop={"1rem"}
          >
            <Box marginBottom={"15px"} marginRight={"5px"}>
              <CustomButton
                color="#3a5396"
                // label="Add Campaign"
                label="Apply Filter"
                onClick={handleSubmit(onFormSubmit)}
              />
            </Box>
            <Box marginBottom={"15px"}>
              <CustomButton
                labelColor="#7a7870"
                variant="outlined"
                color="white"
                label="Close"
                onClick={() => setOpen(false)}
              />
            </Box>
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};

export default CampaignFilters;
